import { render, staticRenderFns } from "./vistaProveedores.vue?vue&type=template&id=68cb0075&scoped=true&"
import script from "./vistaProveedores.vue?vue&type=script&lang=js&"
export * from "./vistaProveedores.vue?vue&type=script&lang=js&"
import style0 from "./vistaProveedores.vue?vue&type=style&index=0&id=68cb0075&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb0075",
  null
  
)

export default component.exports